module.exports = __webpack_public_path__ + "img/0x14a0243C333A5b238143068dC3A7323Ba4C30ECB.2565884a.png";